import { defineComponent as _defineComponent } from 'vue'
import ResizeObserver from 'resize-observer-polyfill';
import { onMounted, ref, onUnmounted, nextTick, watch } from 'vue';
import Pdf from './Pdf';
import PtNodata from '../PtNodata';


export default /*#__PURE__*/_defineComponent({
  __name: 'FileWrapperMultiViewPdf',
  props: {
    pdf: {
        type: String,
        default: '',
    },
    nodataTips: {
        type: String,
        default: '',
    },
},
  setup(__props) {

const props = __props


const observer = ref(null);
const pdfWrapper = ref(null);

const resetPdf = () => {
    const iframe = pdfWrapper.value?.querySelector('iframe');
    if (iframe) {
        iframe.src = props.pdf;
    }
};

onMounted(async () => {
    await nextTick();
    observer.value = new ResizeObserver(resetPdf);
    observer.value.observe(pdfWrapper.value);
});

onUnmounted(() => {
    if (observer.value) {
        observer.value.disconnect();
    }
});

watch(
    () => props.pdf,
    () => {
        resetPdf();
    },
);


return { __sfc: true,props, observer, pdfWrapper, resetPdf, Pdf, PtNodata }
}

})